import { render, staticRenderFns } from "./CompeteHome.vue?vue&type=template&id=0afa4e12&scoped=true&"
import script from "./CompeteHome.vue?vue&type=script&lang=js&"
export * from "./CompeteHome.vue?vue&type=script&lang=js&"
import style0 from "./CompeteHome.vue?vue&type=style&index=0&id=0afa4e12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa4e12",
  null
  
)

export default component.exports